import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import styled from 'styled-components';

import IPage from '../../interfaces/IPage';
import { useLocalStorage } from '../../services/useLocalStorage';

const DialogContentCustom = styled(DialogContent)`
  && {
    h1 {
      font-size: 1rem;
      font-weight: 500;
    }

    p {
      font-size: 0.85rem;
    }
  }
`;

const ButtonCustom = styled(Button)`
  && {
    text-transform: none;
  }
`;

export const OrderHubspot: React.FC<IPage> = props => {
  window.document.title = props.title;

  const localStorage = useLocalStorage();
  const navigate = useNavigate();
  const params = useParams();

  const [message, setMessage] = useState('');

  const [dialogWithoutHubspot, setDialogWithoutHubspot] = useState(false);

  const goToLogin = useCallback(() => {
    if (params.id) {
      navigate(`/?redirectTo=${params.id}`);
      return;
    }
    navigate('/');
  }, [navigate, params.id]);

  useEffect(() => {
    if (!params.id) {
      setMessage('ID da negociação do HubSpot não encontrado.');
      setDialogWithoutHubspot(true);
      return;
    }

    if (localStorage.getItem('@PEDIDO-WEB:user') === null) {
      setMessage('Usuário não encontrado. Por favor, faça login na plataforma.');
      setDialogWithoutHubspot(true);
      return;
    }

    navigate(`/order/steper/0/new?hubspotId=${params.id}`);
  }, []);

  return (
    <>
      <Dialog open={dialogWithoutHubspot}>
        <DialogContentCustom sx={{ width: 'auto' }}>
          <h1>{message}</h1>
        </DialogContentCustom>
        <DialogActions sx={{ justifyContent: 'center', paddingBottom: '24px' }}>
          <ButtonCustom onClick={goToLogin} autoFocus variant="contained">
            OK
          </ButtonCustom>
        </DialogActions>
      </Dialog>
    </>
  );
};
